import { Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { LanguageService } from '../i18n/language.service';
import { PaginationPage, PaginationPageLabel } from './pagination';
import { I18N } from './pagination.component.i18n';
import { PaginationUtils } from './pagination.utils';

/**
 * Diese Komponente ist eine interne Komponente welche eine paginierung der daten liste darstellt.
 */
@Component({
    selector: 'common-pagination',
    templateUrl: 'pagination.component.html'
})
export class PaginationComponent implements OnInit, OnDestroy, OnChanges {

    @Input() showPageSize: boolean;

    @Input() page: PaginationPage;

    @Output('pageChange') pageOutput$: ReplaySubject<PaginationPage> = new ReplaySubject<PaginationPage>(1);

    pageLabels: PaginationPageLabel[];

    i18n: any;

    languageSubscription: Subscription;

    private page$: ReplaySubject<PaginationPage> = new ReplaySubject<PaginationPage>(1);


    constructor(private languageService: LanguageService) {
        this.languageSubscription = languageService.registerForLanguageChanged(this, 'i18n', I18N);
    }

    ngOnInit() {
        this.pageOutput$.subscribe(p => this.page$.next(p));
        this.page$.subscribe(page =>
            this.pageLabels = PaginationUtils.getPageLabels(page.number, page.size, page.totalElements));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('page')) {
            this.page$.next(this.page);
        }
    }

    ngOnDestroy() {
        if (this.languageSubscription) this.languageSubscription.unsubscribe();
        this.page$.complete();
        this.pageOutput$.complete();
    }

    /**
     * Go to the first page
     */
    first() {
        this.setPageNumber(0);
    }

    /**
     * Go to the previous page
     */
    previous() {
        if (this.page.number > 0) {
            this.setPageNumber(this.page.number - 1);
        }
    }

    /**
     * Go to the next page
     */
    next() {
        if (this.page.last) {
            return;
        }
        this.setPageNumber(this.page.number + 1);
    }

    /**
     * Go to the last page
     */
    last() {
        this.setPageNumber(this.page.totalPages - 1);
    }

    /**
     * Set the current page number.
     */
    setPageNumber(pageNumber: number | string) {
        this.pageOutput$.next(PaginationUtils.clone(this.page, { number: +pageNumber }));
    }

    /**
     * Ersetzt die neue Größe der Seite.
     */
    setPageSize(size: number | string) {
        this.pageOutput$.next(PaginationUtils.clone(this.page, { number: 0, size: +size }));
    }
}
